(function () {
  const STATIC_CHECKLIST_ITEMS = ['100% Satisfaction Guarantee', 'Free Shipping'];
  const DEFAULT_SUPPLY_DAYS = '30';

  // Reads the supply days (e.g. "15" from "15-Day Supply") from whichever
  // variant option radio is currently checked, so the delivery line can
  // match the selected variant.
  function getSelectedSupplyDays() {
    const supplyTexts = document.querySelectorAll('.variant-option__supply-text');
    for (const el of supplyTexts) {
      const label = el.closest('label');
      const input = label && label.querySelector('input[type="radio"]');
      if (input && input.checked) {
        const match = el.textContent.match(/\d+/);
        if (match) return match[0];
      }
    }
    return null;
  }

  // Updates the "Delivered Every X-Days" line in every injected checklist
  // to reflect the currently selected variant's supply duration.
  function updateDeliveryText() {
    const days = getSelectedSupplyDays() || DEFAULT_SUPPLY_DAYS;
    const text = `Delivered Every ${days}-Days`;
    document.querySelectorAll('.appstle-custom-checklist__delivery').forEach((li) => {
      // Guard against a no-op write: setting textContent always replaces the
      // text node, which would re-trigger the body-level MutationObserver
      // below and loop forever.
      if (li.textContent !== text) {
        li.textContent = text;
      }
    });
  }

  // Toggle checklist visibility based on whether its parent option is active.
  // Called by a dedicated MutationObserver watching only class attr on option nodes —
  // no event listeners added, so there is no conflict with Appstle's own handlers.
  function updateChecklistVisibility() {
    document.querySelectorAll('.appstle-custom-checklist').forEach((list) => {
      const option = list.closest('.appstle_subscription_wrapper_option');
      if (!option) return;
      list.classList.toggle('appstle-checklist-hidden', !option.classList.contains('appstle-active-option'));
    });
  }

  // Watch for appstle-active-option class changes on the option wrappers.
  // Uses a targeted observer (not body-level attribute watching) to stay lightweight.
  let attrObserver = null;
  function setupAttrObserver() {
    if (attrObserver) attrObserver.disconnect();
    const options = document.querySelectorAll('.appstle_subscription_wrapper_option');
    if (!options.length) return;
    attrObserver = new MutationObserver(updateChecklistVisibility);
    options.forEach((option) => {
      attrObserver.observe(option, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function injectChecklist() {
    let injected = false;

    document.querySelectorAll('.appstle_subscription_wrapper_option').forEach((option) => {
      if (!option.querySelector('.appstle_subscribe_save_text')) return;
      if (option.querySelector('.appstle-custom-checklist')) return;

      const list = document.createElement('ul');
      list.className = 'appstle-custom-checklist';

      const deliveryLi = document.createElement('li');
      deliveryLi.className = 'appstle-custom-checklist__delivery';
      list.appendChild(deliveryLi);

      STATIC_CHECKLIST_ITEMS.forEach((text) => {
        const li = document.createElement('li');
        li.textContent = text;
        list.appendChild(li);
      });

      const radioWrapper = option.querySelector('.appstle_subscription_radio_wrapper');
      if (radioWrapper) {
        radioWrapper.insertAdjacentElement('afterend', list);
      } else {
        option.appendChild(list);
      }

      injected = true;
    });

    if (injected) {
      setupAttrObserver();
      updateChecklistVisibility();
    }

    updateDeliveryText();
  }

  function init() {
    injectChecklist();

    // Watch for Appstle re-renders (variant switches, lazy load, etc.)
    const domObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length) {
          injectChecklist();
          break;
        }
      }
    });
    domObserver.observe(document.body, { childList: true, subtree: true });

    // Radio input "change" events bubble up from the variant picker, so this
    // catches variant switches without needing a mutation-based hook.
    document.addEventListener('change', (event) => {
      if (event.target.matches && event.target.matches('input[type="radio"]')) {
        updateDeliveryText();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
